export default class handlerRespuesta {
  constructor (response, params) {
    if (response !== null) {
      // sacar data de response
      this.status = response.status
      this.datos = response.data
      this.url = response.request.responseURL

      // Si params es un objeto, obtener datos del objeto. Puede ser un FormData
      // o un diccionario
      // Este diccionario sólo se usa al mostrar dialogo de error desconocido
      if (typeof params === 'object') {
        if (Object.keys(params).length > 0) {
          // params es un diccionario normal
          this.params = params
        } else {
          // *es posible* que params sea un FormData. Tratar de convertir a diccionario
          // sino dejar this.params como nulo
          try {
            this.params = {}
            for (let par of params.entries()) {
              this.params[par[0]] = par[1]
            }
          } catch (error) {}
        }
      }
    }
  }

  hayErrores () {
    if (this.errorUsuario !== '') {
      return true
    }

    return false
  }

  getError () {
    return 'Mensaje: ' + this.datos.message + ' | Excepcion: ' + this.status
  }
}



// WEBPACK FOOTER //
// ./src/utils/handler_respuesta_api.js